import request from '@/utils/request'
// 引入封装axios服务
// request 二次处理
// import awaitWrap from '@/utils/awaitWrap'

const baseURL = process.env.VUE_APP_BASE_API
// const baseURL = 'http://192.168.27.68:8080' // 唐代红

/**
 * 获取json 新对象，去掉空字段
 * @param {Object} data
 * @returns
 */
export function getClearJson(data) {
  const _data = {}
  for (const prop in data) {
    const item = data[prop]
    if (item !== undefined && item) {
      _data[prop] = item
    }
  }
  return _data
}

/**
 * requestB baserUrl重写
 * @param {Object} data
 * @returns
 */
const requestB = (data) => {
  return request({
    ...data,
    ...{
      baseURL
    }
  })
}

// 登录
export function login(data) {
  return requestB({
    url: '/userLogin/login',
    method: 'post',
    data
  })
}

// export function getInfo(token) {
//   return request({
//     url: '/vue-element-admin/user/info',
//     method: 'get',
//     params: { token }
//   })
// }

// 登出
export function logout(data) {
  return requestB({
    url: `${data ? `/userLogin/exit?ssoToken=${data}` : `/userLogin/exit`}`,
    method: 'post'
  })
}

// 获取用户信息
export function getInfo() {
  return requestB({
    url: '/common/getAccountInfo',
    method: 'post'
  })
}

// 获取用户所在企业列表
export function getCompanyInfo() {
  return requestB({
    url: '/userLogin/getEnterpriseList',
    method: 'get'
  })
}

// 切换公司
export function switchCompany(data) {
  console.log('data', data)
  return requestB({
    url: '/userLogin/switchEnterprise',
    method: 'post',
    data
  })
}

